
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'FilenameOption'
})
export default class extends Vue {
  @Prop({ required: true }) private value!: string

  get filename() {
    return this.value
  }

  set filename(value) {
    this.$emit('input', value)
  }
}
